<template>
	<div>
		<modalconfirm ref="modalconfirmAddSO" @action="proccessSO"/>
		<div class="text-h5">Tambah Sales Order</div>
		<v-card class="mt-3" outlined id="form-add-so">
			<v-form ref="formSO" role="form" v-on:submit.prevent="addSO">
				<v-card-text class="pt-2">
					<!-- <v-alert v-if="responseError.product" v-model="responseError.product" dismissible type="error" elevation="2">
						{{responseError.product}}
					</v-alert> -->
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<div class="text-h6">Form Pelanggan</div>
							<v-row>
								<v-col cols="8" class="py-0">
									<v-autocomplete v-model="so_customer_search_value" :loading="isLoading" :items="customerSearchList" :search-input.sync="search" item-text="customer_name" flat hide-details outlined dense label="Masukan Kode atau Nama Pelanggan" return-object :filter="customFilterCustomer" hide-no-data>
										<template v-slot:item = {item}>
											{{ item.customer_name }} ({{ item.customer_network_code }})
										</template>
										<template v-slot:selection = {item}>
											{{ item.customer_name }} ({{ item.customer_network_code }})
										</template>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="12" md="12" class="mb-n6">
							<v-row>
								<v-col cols="4" class="py-0">
									<v-text-field readonly v-model="customer_network_code" :rules="[inputrules.required]" label="Kode Pelanggan" @focus="() => responseError.network_code=''" :error-messages="responseError.network_code" outlined dense hide-no-data hide-selected></v-text-field>
								</v-col>
								<v-col cols="4" class="py-0">
									<v-autocomplete :readonly="customer_system == 'system'" item-text="text" item-value="value" outlined dense v-model="customer_system" :rules="[inputrules.required]" :items="listSystemAvailable" label="Metode Transaksi" @focus="() => responseError.system=''" :error-messages="responseError.system" class="width-0" no-data-text="Tidak ada data yang sesuai">
									</v-autocomplete>
								</v-col>
								<v-col cols="4" class="py-0" v-if="customer_level == 'pramb'">
									<v-text-field label="Level" :value="customer_level.toUpperCase() + ' ' + customer_order_count" readonly outlined dense></v-text-field>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-text-field readonly v-model="customer_name" label="Nama" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-textarea readonly v-model="customer_address" label="Alamat" rows="2" height="80" hide-details="auto" outlined dense no-resize></v-textarea>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-text-field readonly v-model="customer_mobilephone" @keydown="onlyNumber" label="No. Handphone" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-textarea v-model="so_note" label="Catatan" rows="4" height="80" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4" v-if="false">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-autocomplete :items="OptionPaymentMethod" v-model="so_payment" :rules="[inputrules.required]" label="Tipe Pembayaran" placeholder="Tipe Pembayaran" no-data-text="Tidak ada data yang sesuai" @focus="() => responseError.payment_method=''" :error-messages="responseError.payment_method" item-text="text" item-value="code" outlined dense>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-textarea v-model="so_payment_note" label="Catatan Pembayaran" placeholder="Contoh : BRI Rp 2.0000.000" rows="4" height="80" @focus="() => responseError.payment_note=''" :error-messages="responseError.payment_note" hide-details="auto" outlined dense no-resize></v-textarea>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" md="12">
							<v-row>
								<v-col cols="4">
									<div class="text-h6">Diskon (%)</div>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="4">
									<v-currency-field v-model="discount_percentage" :max="100" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white" @focus="() => responseError.discount_percentage=''" :error-messages="responseError.discount_percentage" :decimalLength="2"></v-currency-field>
								</v-col>
							</v-row>
						</v-col>
						<!-- <v-col cols="12" md="4">
							<div class="text-h6">Biaya Pengiriman</div>
							<v-row>
								<v-col cols="4">
									<v-currency-field v-model="delivery_price" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white" @focus="() => responseError.delivery_price=''" :error-messages="responseError.delivery_price" :decimalLength="2"></v-currency-field>
								</v-col>
							</v-row>
						</v-col> -->
						<v-col cols="12">
							<div class="text-h6">Data Produk</div>
							<v-alert dense text type="error" elevation="0" v-if="responseError.product">
								<div class="text-body-2">{{responseError.product}}</div>
							</v-alert>
							<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="25%" class="text-left">Nama Produk</th>
											<th width="10%" class="text-right">Harga (Rp)</th>
											<th width="15%" class="text-left">Jumlah</th>
											<th width="15%" class="text-left">Satuan</th>
											<th width="15%" class="text-right">Sub Total (Rp)</th>
											<!-- <th width="30%" class="text-left">Serial</th> -->
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productsSelected" :key="product.product_id">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletefromSO(index)">
															<v-icon dark>mdi-delete</v-icon>
														</v-btn>
													</template>
													<span>Hapus</span>
												</v-tooltip>
											</td>
											<td>
												<v-autocomplete :items="productsNotSelected" :filter="customFilter" return-object item-text="product_name" placeholder="Pilih Produk" v-model="product.data" no-data-text="Tidak ada data yang sesuai" :rules="[productRules]" class="py-2 details-mb-0 width-0" outlined dense hide-details="auto" background-color="white">
													<template v-slot:item = {item}>
														{{item.product_code}} - {{item.product_name}} ({{item.product_unit}})
													</template>
													<template v-slot:selection = {item}>
														{{item.product_name}}
													</template>
												</v-autocomplete>
											</td>
											<td class="text-right"> {{ (customer_order_count >= 4 || customer_level == 'mb' || promo77()) ? (product.data.price_original ? product.data.price_original : 0) : (product.data.price ? product.data.price : 0) | toNumber }} </td>
											<td>	
												<v-currency-field v-model="product.data.quantity" :rules="[inputrules.required, inputrules.notnull]" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
											</td>
											<td> {{ product.data.product_unit }} </td>
											<td class="text-right"> {{ ((customer_order_count >= 4 || customer_level == 'mb' || promo77()) ? (product.data.price_original ? product.data.price_original : 0) : (product.data.price ? product.data.price : 0) * product.data.quantity) | toNumber }} </td>
											<!-- <td v-if="product.data.product_is_serial > 0">
												<v-text-field v-model="product.data.serial" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white" placeholder="M0000000001-M0000000010.M0000000021"></v-text-field>
											</td> -->
										</tr>
									</tbody>
									<tfoot v-if="grandTotal > 0">
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Subtotal</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</div>
											</td>
										</tr>
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Tambahan Ongkos Kirim</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">
													<v-currency-field v-model="delivery_price" :allow-negative="false" :max="discount_percentage > 100 ? 0 : grandTotal + delivery_price - discountTotal" reverse suffix="Rp " class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
												</div>
											</td>
										</tr>
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Total Diskon</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ discountTotal | toRupiah }}</div>
											</td>
										</tr>
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Total Harga</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ grandTotal + delivery_price - discountTotal | toRupiah }}</div>
											</td>
										</tr>
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Potongan Harga</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">
													<v-currency-field v-model="rebate_value" :allow-negative="false" :max="discount_percentage > 100 ? 0 : grandTotal + delivery_price - discountTotal" reverse suffix="Rp " class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
												</div>
											</td>
										</tr>
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Total Bayar</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ (grandTotal + delivery_price - discountTotal - rebate_value) | toRupiah }}</div>
											</td>
										</tr>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
						<v-col cols="12" class="pt-0">
							<v-btn light depressed color="primary" @click="addProduct" :disabled="!so_customer_search_value">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Produk</div>
							</v-btn>
						</v-col>
						<!-- Fitur Pembayaran -->
						<v-col cols="12">
							<div class="text-h6">Pembayaran</div>
							<v-alert dense text type="error" elevation="0" v-if="responseError.payment">
								<div class="text-body-2">{{responseError.payment}}</div>
							</v-alert>
							<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="30%" class="text-left">Pembayaran</th>
											<th width="20%" class="text-left">Nominal</th>
											<th width="45%" class="text-left">Catatan</th>
											<!-- <th width="30%" class="text-left">Serial</th> -->
										</tr>
									</thead>
									<tbody>
										<tr v-for="(payment, index) in paymentSelected" :key="index">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletePaymentSO(index)">
															<v-icon dark>mdi-delete</v-icon>
														</v-btn>
													</template>
													<span>Hapus</span>
												</v-tooltip>
											</td>
											<td>
												<v-autocomplete @input="selectPayment($event, index)" :items="paymentsNotSelected" return-object item-text="text" placeholder="Pilih Tipe Pembayaran" no-data-text="Tidak ada data yang sesuai" :rules="[paymentRules]" class="py-2 details-mb-0 width-0" outlined dense hide-details="auto" background-color="white">
												</v-autocomplete>
											</td>
											<td>
												<v-currency-field v-model="payment.data.payment_value" :rules="[inputrules.required]" placeholder="Nominal" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
											</td>
											<td>
												<v-text-field v-model="payment.data.payment_note" placeholder="Catatan" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-text-field>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr v-if="productsSelected.length > 0">
											<td colspan="6">
												<div class="d-flex justify-end pt-3">
													<div class="font-weight-bold text-right px-4">Total Dibayarkan</div>
													<div class="font-weight-bold text-right">{{ grandTotalPayment | toRupiah }}</div>
												</div>
											</td>
										</tr>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
						<v-col cols="12" class="pt-0">
							<v-btn light depressed color="primary" @click="addPayment" :disabled="!so_customer_search_value">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Pembayaran</div>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-4 pb-4">
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" depressed class="text-capitalize" type="submit">Proses</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'
import _ from 'lodash';

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			isLoading: false,
			search: null,
			customerSearchList: [],
			so_customer_search_value: '',
			so_payment: '',
			customer_system: '',
			productsSelected: [],
			paymentSelected: [],
			so_note: '',
			so_payment_note: '',
			customer_network_code: '',
			customer_name: '',
			customer_mobilephone: '',
			customer_address: '',
			customer_level: '',
			customer_order_count: '',
			customer_province_id: '',
			discount_percentage: 0,
			delivery_price: 0,
			rebate_value: null,
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
			paymentRules: value => {
				if (value) {
					return !!value.code || 'Tidak boleh kosong'
				} else {
					return true
				}
			},
			listSystem: [{
				value: 'not_selected',
				text: 'Belum terpilih'
			}, {
				value: 'manual',
				text: 'Tanpa Sistem'
			}, {
				value: 'system',
				text: 'Melalui Sistem'
			}],
		}
	},
	props: {
	},
	computed: {
		...mapState('so', ['listProduct', 'response', 'responseError', 'OptionPaymentMethod']),

		listSystemAvailable() {
			return this.listSystem.map(el => {
				let element = Object.assign({}, el)
				element.disabled = false
				if (this.customer_system != 'not_selected' && element.value == 'not_selected') {
					element.disabled = true
				}
				return element
			})
		},
		paymentsNotSelected() {
			if (this.paymentSelected.length > 0) {
				const paymentSelected = this.paymentSelected.map((el) => el.data)
				return this.OptionPaymentMethod.map((el) => {
					if (paymentSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.OptionPaymentMethod
		},
		productsNotSelected() {
			if (this.productsSelected.length > 0) {
				const productSelected = this.productsSelected.map((el) => el.data)
				return this.listProduct.map((el) => {
					if (productSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.listProduct
		},
		grandTotal(){
			let total = 0
				this.productsSelected.forEach( (el) => {
					let price = (this.customer_order_count >= 4 || this.customer_level == 'mb' || this.promo77()) ? (el.data.price_original ? el.data.price_original : 0) : (el.data.price ? el.data.price : 0)
					let quantity = el.data.quantity ? el.data.quantity : 0
					total += price * quantity
				});

			return total
		},
		discountTotal() {
			return parseInt(this.discount_percentage * this.grandTotal / 100)
		},
		grandTotalPayment(){
			let total = 0
			this.paymentSelected.forEach( (el) => {
				let price = el.data.payment_value ? el.data.payment_value : 0
				total += price
			});

			return total
		},
		addressText() {
			var data = []
			if (this.so_customer_search_value.customer_address)
				data.push(this.so_customer_search_value.customer_address)
			if (this.so_customer_search_value.customer_subdistrict_name)
				data.push(this.so_customer_search_value.customer_subdistrict_name)
			if (this.so_customer_search_value.customer_city_name)
				data.push(this.so_customer_search_value.customer_city_name)
			if (this.so_customer_search_value.customer_province_name)
				data.push(this.so_customer_search_value.customer_province_name)
			return data.join(', ')
		},
	},
	methods: {
		...mapActions('so', ['createSO', 'getOptionProduct', 'getOptionPaymentMethod', 'detailCustomer', 'searchCustomer', 'getProductShippingPrice']),
		...mapMutations('so', ['saveResponse', 'clearDataSO', 'setDetailCustomer']),
		...mapMutations(['setOverlay']),
		...mapMutations(['setSnackbar']),

		customFilter (item, queryText) {
			const textOne = item.product_code.toLowerCase()
			const textTwo = item.product_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		addPayment() {
			this.responseError.payment = ''
			this.paymentSelected.push({
				data: {
					code: "",
					text: "",
					payment_note: "",
					payment_value: 0,
				},
			})
		},
		selectPayment(value, index) {
			this.paymentSelected[index].data = Object.assign({}, value)
		},
		addProduct() {
			this.responseError.product = ''
			this.productsSelected.push({
				data: {
					product_id: '',
					product_name: '',
					quantity: '0',
				},
			})
		},
		deletefromSO(index){
			this.productsSelected.splice(index, 1)
		},
		deletePaymentSO(index){
			this.paymentSelected.splice(index, 1)
		},
		addSO() {
			if (this.$refs.formSO.validate() && this.productsSelected.length > 0) {
				this.$refs.modalconfirmAddSO.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
				this.$refs.modalconfirmAddSO.showConfirm()
				// this.checkPaymentValue().then( () => {
				// 	this.$refs.modalconfirmAddSO.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
				// 	this.$refs.modalconfirmAddSO.showConfirm()
				// }).catch(() => {
				// 	this.setSnackbar({
				// 		show: true,
				// 		color: 'red darken-2',
				// 		text: 'Total pembayaran yang anda masukan tidak sesuai'
				// 	})
				// })
			}
		},
		checkPaymentValue() {
			return new Promise((resolve, reject) => {
				let totalPayment = 0
				this.paymentSelected.forEach( el => {
					if (el.data.payment_value) {
						totalPayment += el.data.payment_value
					}
				})

				let totalProductPrice = 0
				this.productsSelected.forEach( (el) => {
					totalProductPrice += el.data.quantity * ((this.customer_order_count >= 4 || this.customer_level == 'mb') ? el.data.price_original : el.data.price)
				})

				if (totalPayment === totalProductPrice) {
					resolve()
				} else {
					reject()
				}
			});
		},
		async proccessSO() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddSO.hideConfirm()
			let product = await this.productsSelected.map( (el) => {
				return {
					product_name: el.data.product_name,
					product_id: el.data.product_id,
					quantity: el.data.quantity,
					price: el.data.price,
				}
			})
			let payment = await this.paymentSelected.map( el => {
				return {
					payment_name: el.data.text,
					payment_value: el.data.payment_value,
					payment_note: el.data.payment_note,
				}
			})
			let params = await {
				network_code: this.customer_network_code,
				discount_percentage: this.discount_percentage,
				discount_value: this.discountTotal,
				rebate_value: this.rebate_value,
				delivery_value: this.delivery_price,
				system: this.customer_system,
				note: this.so_note,
				product: product,
				payment: payment
			}
			await this.createSO(params).then( async () => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			}).catch( async () => {
				document.querySelector("html").scrollTop = await 0
			})
			await this.setOverlay(false)
			document.querySelector("html").scrollTop = await 0
		},
		resetForm(){
			this.saveResponse({})
			this.setDetailCustomer({})
			this.paymentSelected = []
			this.productsSelected = []
			this.payment_note = ''
			this.$refs.formSO.resetValidation()
			this.so_customer_search_value = ''
			this.so_payment = ''
			this.so_payment_note = ''
			this.so_note = ''
			this.customer_name = ''
			this.customer_level = ''
			this.customer_mobilephone = ''
			this.customer_address = ''
			this.discount_percentage = 0
			this.delivery_price = 0
		},
		customFilterCustomer (item, queryText) {
			const textOne = item.customer_name.toLowerCase()
			const textTwo = item.customer_network_code.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
    promo77() {
      let D1 = new Date("2022-07-31");
      let D2 = new Date("2022-08-31");
      let D3 = new Date();

      if (D3.getTime() <= D2.getTime() && D3.getTime() >= D1.getTime()) {
          return true
      } else {
          return false
      }
    }
	},
	created() {
		this.$store.dispatch('setPageTitle', `Tambah Sales Order`)
		this.getOptionProduct({limit:100})
		this.getOptionPaymentMethod()
	},
	beforeDestroy(){
		this.clearDataSO()
	},
	watch: {
		so_customer_search_value() {
			if (this.so_customer_search_value) {
				let order_count = parseInt(this.so_customer_search_value.customer_order_count)
				this.customer_network_code = this.so_customer_search_value.customer_network_code
				this.customer_name = this.so_customer_search_value.customer_name
				this.customer_mobilephone = this.so_customer_search_value.customer_mobilephone
				this.customer_address = this.addressText
				this.customer_level = this.so_customer_search_value.customer_level
				this.customer_system = this.so_customer_search_value.customer_trx_method
				this.customer_order_count =  order_count + 1
				this.customer_province_id = this.so_customer_search_value.customer_province_id
			} else {
				this.customer_network_code = ''
				this.customer_name = ''
				this.customer_mobilephone = ''
				this.customer_address = ''
				this.customer_level = ''
				this.customer_system = ''
				this.customer_order_count = ''
				this.customer_province_id = ''
			}
		},
		productsSelected: {
			handler(newVal, oldVal) {
				if(!oldVal) return

				newVal.forEach( (el) => {
					if (el.data.product_id) {
						this.getProductShippingPrice({product_id: el.data.product_id, province_id: this.customer_province_id}).then( (res) => {
							if(res !== null){
								this.delivery_price = el.data.quantity * res.shipping_area_price
							}
						})
					}
				})
			},
			deep: true
		},
		search: {
			handler: _.debounce(function() {
				if (!this.search)
					return
				else if (this.search.length <= 3)
					return

				this.isLoading = true
				this.searchCustomer(this.search).then( (val) => {
					this.customerSearchList = val
				}).catch(() => {
					this.customerSearchList = []
				}).finally(() => {
					this.isLoading = false
				})
			}, 700),
		}
	}
};
</script>
